import { matchNavPath } from '@app/components/Page/utils/matchNavPath';
import type { NNavigation } from '@app/types';
import { checkForAllPathEnds } from '@app/utils';

export const findPageByPath = (
  items: NNavigation.NavigationAllItems[],
  path: string
): NNavigation.NavigationAllItems | undefined => {
  for (const item of items) {
    if (checkForAllPathEnds(path, item.path)) return item;
    if (matchNavPath(path, item.path)) return item;
    if (item.children) {
      const found = findPageByPath(
        item.children as NNavigation.NavigationAllItems[],
        path
      );
      if (found) return found;
    }
  }
  return undefined;
};
